export default [
	{
		key: 'date',
		title: 'Trx Date',
		scopedSlots: {customRender: 'date'}
	}, {
		key: 'time',
		title: 'Trx Time',
		scopedSlots: {customRender: 'time'}
	}, {
		key: 'pan',
		title: 'PAN',
		scopedSlots: {customRender: 'pan'}
	}, {
		key: 'merchant_code',
		title: 'Merchant Code',
		scopedSlots: {customRender: 'merchant_code'}
	}, {
		key: 'type',
		title: 'Type',
		scopedSlots: {customRender: 'type'}
	}, {
		key: 'issuer_name',
		title: 'Issuer Name',
		scopedSlots: {customRender: 'issuer_name'}
	}, {
		key: 'acquirer_host_type',
		title: 'Acquirer Host',
		scopedSlots: {customRender: 'acquirer_host_type'}
	}, {
		key: 'amount',
		title: 'Amount',
		scopedSlots: {customRender: 'amount'}
	}, {
		key: 'tid',
		title: 'Terminal ID',
		scopedSlots: {customRender: 'tid'}
	}, {
		key: 'mid',
		title: 'Merchant ID',
		scopedSlots: {customRender: 'mid'}
	}, {
		key: 'stan',
		title: 'STAN',
		scopedSlots: {customRender: 'stan'}
	}, {
		key: 'rrn',
		title: 'RRN',
		scopedSlots: {customRender: 'rrn'}
	}, {
		key: 'response_code',
		title: 'Response Code',
		scopedSlots: {customRender: 'response_code'}
	}
]
